module.exports = __webpack_public_path__ + "assets/img/sampleLife.0b327978.png";